import { isRangeNumber, isValue } from '../helpers';
import {
  ICommonResponse,
  IFinalResponse,
  IGenericResponseData,
  ErrorsDetailsTypes,
} from '../types';

import { handleCodeErrorsResponse } from './codeErrorsResponse';
import { STATUS_SERVICE_SUCCESS } from './constants';

export const prepareGenericData = (params: {
  contexts: (ICommonResponse | IFinalResponse | null)[];
  keys: string[];
  definitions: unknown[] | null | undefined;
}): IGenericResponseData => {
  const { contexts, keys, definitions } = params;
  const errors: ErrorsDetailsTypes[] = [];

  let finalResponse: IGenericResponseData = {
    data: null,
    errors: [],
  };

  let eachResponseAvaiable = {},
    eachHeaders = {};
  contexts.forEach((context, i) => {
    if (
      isValue(context?.statusCode) &&
      typeof context?.statusCode === 'number'
    ) {
      if (isRangeNumber(context.statusCode, STATUS_SERVICE_SUCCESS)) {
        eachResponseAvaiable = context?.response;
        eachHeaders = context?.headers;
      } else {
        errors.push({
          entity: context?.errorMetadata || keys[i],
          errorCode: context?.errorCode,
          errorMessage: context?.errorMessage,
          errorMetadata: keys[i],
        });
      }
    } else {
      eachResponseAvaiable = context?.response;
      eachHeaders = context?.headers;
    }
  });

  const infos = handleCodeErrorsResponse({ errors, definitions });
  let finalData = null;
  if (
    typeof eachResponseAvaiable === 'string' ||
    Array.isArray(eachResponseAvaiable) ||
    typeof eachResponseAvaiable === 'object'
  ) {
    finalData = eachResponseAvaiable;
  }
  finalResponse = {
    data: finalData,
    headers: eachHeaders,
    errors: errors,
    infos,
  };
  return finalResponse;
};
//   statusCodesToRetry: [[100, 199], [429, 429], [500, 599]],
